import Animator from "./components/Animator";
import useAnimator from "./hooks/useAnimator";

export default {
	Animator,
	useAnimator,
};
